var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-form',[_c('a-result',{staticStyle:{"max-width":"560px","margin":"40px auto 0"},attrs:{"status":"success","title":"报名成功","is-success":true,"sub-title":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }